export const parseHTMLContent = (htmlString) => {
  const parser = new DOMParser();

  const doc = parser.parseFromString(htmlString, "text/html");
  const images = Array.from(doc.querySelectorAll("img")).map((el) => el.src);

  doc.querySelectorAll("figure, img").forEach((el) => el.remove());

  const text = doc.body.innerHTML;

  return { images, text };
};
